import Animation from './animation'
import * as d3 from 'd3-selection'
import { EPSILON } from 'chart-constants'

/*
 * Depth change animation. e.g. showing 2 levels of descendants and new data
 * reveals 3 levels
 */
class DepthChangeAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
  }

  match () {
    if (!this.chart.previous) {
      return false // not an update
    }

    return this.previousDepth !== this.depth
  }

  animate (serie, enter, selection, merged, exit) {
    if (exit.size()) {
      // Nodes are removed, so we're showing less depth
      // Fade out the nodes
      exit.duration(this.timing.duration)
          .style('opacity', EPSILON)
          .remove()

      // Delay the move until the 2nd part of the animation
      merged.duration(this.timing.duration)
            .delay(this.timing.duration)
            .call(this._labels)
    } else {
      // Put new nodes in their final position
      enter.attr('transform', d => `translate(${d.x0},${d.y0})`)
         .style('opacity', EPSILON)
         .select('rect')
         .attr('fill', d => this.colorScale(d.data.level))
         .attr('width', d => d.x1 - d.x0)
         .attr('height', d => d.y1 - d.y0)

      enter.select('.label')
           .select(function () {
             // Move the labels to their final state so they fade in
             // at the proper location
             d3.select(this)
               .style('font-size', this._fontSize)
               .attr('transform', this._transform)
             return this
           })

      // Move the labels
      merged.duration(this.timing.duration)
            .call(this._labels)
            .transition()
            .style('opacity', 1) // then show the new nodes
    }
  }

}

export default DepthChangeAnimation
